import { useEffect, useState } from "react";

const navLinks = [
  { id: "top", label: "首页" },
  { id: "hot", label: "今日热瓜" },
  { id: "archive", label: "事件档案" },
  { id: "latest", label: "最新动态" },
  { id: "guide", label: "吃瓜指南" },
  { id: "about", label: "关于我们" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("top");

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 8);
      let current = "top";
      navLinks.forEach((link) => {
        const el = document.getElementById(link.id);
        if (el && el.getBoundingClientRect().top <= 140) current = link.id;
      });
      setActive(current);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const goTo = (id: string) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className="fixed inset-x-0 top-0 z-50">
      {/* top ticker bar */}
      <div className="bg-primary-900 text-primary-100">
        <div className="section-wrap flex items-center gap-3 py-1.5 text-xs">
          <span className="flex items-center gap-1 whitespace-nowrap bg-primary-500 px-2 py-0.5 text-[11px] font-semibold text-white">
            <i className="ri-fire-line"></i> 瓜讯速递
          </span>
          <div className="relative hidden h-5 flex-1 overflow-hidden sm:block">
            <div className="ticker-track absolute inset-0 flex flex-col">
              {[0, 1].map((k) => (
                <div key={k} className="flex h-5 items-center gap-8">
                  <span>【持续发酵】沉浸式综艺剪辑争议，导演长文后口碑分化</span>
                  <span>【本日热议】素人主播直播翻车，宣布停播一周复盘</span>
                  <span>【最新进展】新消费咖啡联名抄袭案双方已达成和解</span>
                  <span>【跟进中】县城老街夜市开设意见征集通道</span>
                </div>
              ))}
            </div>
          </div>
          <div className="ml-auto flex items-center gap-3 whitespace-nowrap sm:ml-0">
            <span className="hidden items-center gap-1 md:flex">
              <i className="ri-calendar-line"></i> 2026年9月8日
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i> 今日 12.8万人在线吃瓜
            </span>
          </div>
        </div>
      </div>

      {/* main nav */}
      <div
        className={`transition-all duration-300 ${
          scrolled
            ? "border-b border-background-200 bg-background-50/95 backdrop-blur-md"
            : "bg-transparent"
        }`}
      >
        <div className="section-wrap flex items-center justify-between py-3">
          <a
            href="#top"
            onClick={(e) => {
              e.preventDefault();
              goTo("top");
            }}
            className="flex items-center gap-2.5"
          >
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-600 text-lg text-white">
              <i className="ri-goblet-fill"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-serif-editorial text-xl font-black text-foreground-950">
                天涯吃瓜
              </span>
              <span className="mt-1 text-[10px] tracking-widest text-foreground-500">
                事件梳理与来龙去脉
              </span>
            </span>
          </a>

          <nav className="hidden items-center gap-1 lg:flex">
            {navLinks.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  goTo(l.id);
                }}
                className={`rounded-full px-4 py-2 text-sm transition-colors ${
                  active === l.id
                    ? "bg-primary-600 font-medium text-white"
                    : "text-foreground-700 hover:bg-background-200/70 hover:text-primary-700"
                }`}
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#submit"
              onClick={(e) => {
                e.preventDefault();
                goTo("submit");
              }}
              className="hidden items-center gap-2 whitespace-nowrap rounded-full bg-primary-600 px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-primary-700 sm:flex"
            >
              <i className="ri-mail-send-line"></i> 投稿线索
            </a>
            <button
              onClick={() => setOpen((v) => !v)}
              aria-label="打开菜单"
              className="flex h-10 w-10 items-center justify-center rounded-full border border-background-300 text-foreground-800 lg:hidden"
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
            </button>
          </div>
        </div>
      </div>

      {/* mobile drawer */}
      {open && (
        <div className="border-b border-background-200 bg-background-50 shadow-lg lg:hidden">
          <nav className="section-wrap flex flex-col gap-1 py-4">
            {navLinks.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  goTo(l.id);
                }}
                className={`flex items-center justify-between rounded-xl px-4 py-3 text-[15px] ${
                  active === l.id
                    ? "bg-primary-600 font-medium text-white"
                    : "text-foreground-800 hover:bg-background-200/70"
                }`}
              >
                {l.label}
                <i className="ri-arrow-right-s-line text-lg"></i>
              </a>
            ))}
            <a
              href="#submit"
              onClick={(e) => {
                e.preventDefault();
                goTo("submit");
              }}
              className="mt-2 flex items-center justify-center gap-2 rounded-xl bg-primary-600 px-4 py-3 text-[15px] font-medium text-white"
            >
              <i className="ri-mail-send-line"></i> 投稿线索
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}